import React from 'react';
import FreightCostTable from './FreightCostTable';

const ProductHydroTable = ({ refreshTrigger }) => (
  <FreightCostTable procurementTypeHeader='1' refreshTrigger={refreshTrigger} />
);

export default React.memo(ProductHydroTable);
